export default function InputValidationWarning({ warning }) {
    return (
        <>
            {warning && (
                <span style={{ color: "#BF211E", fontSize: ".75rem" }}>
                    {warning}
                </span>
            )}
        </>
    )
}